import { defineStore } from 'pinia'
import { getNavigationMenu } from '~/composables/api'
import { STORE_ID } from '~/constants/store' // not reactive, cannot destructure
import type { NavigationMenuState as State } from '~/types/navigationMenu'
import { isExpectedApiNetworkControlError } from '~/utils/apiError'

const initialState = (): State => ({
  items: [],
  fetching: {
    items: false
  },
  fetchDidFail: {
    items: false
  },
  lastUpdated: {
    items: undefined
  },
  lastFailed: {
    items: undefined
  }
})

/**
 * @name useNavigationMenuStore
 * @description Store for user menu displayed across the app
 *
 */
const useNavigationMenuStore = defineStore(STORE_ID.NAVIGATION_MENU, {
  state: initialState,

  getters: {},

  actions: {
    fetchNavigationMenu: async function () {
      if (this.fetching.items) {
        return
      }
      this.fetching.items = true

      try {
        const res = await getNavigationMenu()
        this.items = res.items ?? []
        this.fetchDidFail.items = false
        this.lastFailed.items = undefined
        this.lastUpdated.items = Date.now()
      } catch (error: any) {
        // items are cleared on error
        if (!isExpectedApiNetworkControlError(error)) {
          console.error('Error fetching navigation menu', error)
        }
        this.clearNavigationMenu()
        this.fetchDidFail.items = true
        this.lastFailed.items = Date.now()
      } finally {
        this.fetching.items = false
      }
    },
    clearNavigationMenu: function () {
      this.items = []
      this.fetching.items = false
      this.fetchDidFail.items = false
    }
  },
  persist: true
})

export default useNavigationMenuStore
export { initialState }
